<template>
  <div class="mars-ape-layout-footer">
    <div class="mars-ape-layout-footer-copyright">
      <a href="https://beian.miit.gov.cn/" target='_blank'>{{siteInfo.copyright||"Copyright 2021~2026 杭州缇苏文化传播有限公司 | 备案号：浙ICP备18052836号-1"}}</a>
    </div>
    <div class="mars-ape-layout-footer-link">
    </div>
  </div>
</template>
<script>

import { mapGetters } from 'vuex'

export default {
  name: 'Footer',
  computed: {
    ...mapGetters(['siteInfo'])
  },
}
</script>
<style lang="scss">
.mars-ape-layout-footer {
  font-size: 14px;
  padding: 0 16px;
  //margin 18px 0 18px
  text-align: center;
  //color white
}

.mars-ape-layout-footer-link {
  margin-bottom: 8px;
}

.mars-ape-layout-footer-copyright {
  a {
    color: #1890ff;
    text-decoration: none;
  }
}
</style>
<style>
.mars-ape-layout-footer {
  /*background-image: url("../src/assets/footer.png");*/
}
</style>
